var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookFont(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0527 14.1973L12.1484 10.7344H12.1895L13.3086 14.1973H11.0527Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 1.25C4.89543 1.25 4 2.14543 4 3.25V20C4 21.1046 4.89543 22 6 22H19C19.5523 22 20 21.5523 20 21V6C20 5.53404 19.6813 5.14251 19.25 5.0315V2.75C19.6642 2.75 20 2.41421 20 2C20 1.58579 19.6642 1.25 19.25 1.25H6ZM17.75 2.75V5H6.5C5.94772 5 5.5 4.55228 5.5 4V3.75C5.5 3.19772 5.94772 2.75 6.5 2.75H17.75ZM9.32422 17.6836C8.77344 17.6836 8.42773 17.3613 8.42773 16.8516C8.42773 16.7051 8.46875 16.5059 8.54492 16.2891L10.8535 10.002C11.0996 9.31641 11.5156 9 12.1836 9C12.875 9 13.2852 9.30469 13.5371 9.99609L15.8574 16.2891C15.9395 16.5176 15.9688 16.6758 15.9688 16.8516C15.9688 17.3379 15.5996 17.6836 15.084 17.6836C14.5859 17.6836 14.3223 17.4551 14.1641 16.9043L13.7188 15.5684H10.666L10.2207 16.8867C10.0566 17.4492 9.79297 17.6836 9.32422 17.6836Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookFont);
export default __webpack_public_path__ + "static/media/book-font.b5a475701698a020428a91b7b643664e.svg";
export { ForwardRef as ReactComponent };